export default __webpack_public_path__ + "static/2132-14024ec49b67893f315cc58318b6f4ca.gif";